export const contactsData = {
    email: 'dhivyadharshni910@gmail.com',
    phone: '+919444115313',
    address: 'New Perungalathur, Chennai, Tamil Nadu, India',

    sheetAPI: ''
}